import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Cutttingedge(props) {
  return (
    <div
      className="p-100 ready_ae"
      style={{ background: "#F47A1F", height: "unset" }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={10}
            lg={8}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>Let’s Discuss Your Project!</h2>
            <p>
              We're excited to assist you in reaching your objectives and
              converting them into a high-quality digital solution. Claim your
              free consultation now!
            </p>
            <Link
              to={`tel:${props?.tel}`}
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Book A Quick Call!
            </Link>
            <p>
              Or, drop your details in the form below to share your
              requirements.
            </p>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Cutttingedge;
